import { render, staticRenderFns } from "./DadosEndereco.vue?vue&type=template&id=0255213a&scoped=true&"
import script from "./DadosEndereco.vue?vue&type=script&lang=js&"
export * from "./DadosEndereco.vue?vue&type=script&lang=js&"
import style0 from "./DadosEndereco.vue?vue&type=style&index=0&id=0255213a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255213a",
  null
  
)

export default component.exports